import SiafLiteApiRepository from "../../external/siafLiteApi";

class ExportacaoBalancaService {
  constructor() {
    this.urlBase = "/estoque/exportacao-balanca";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getUltimoLog() {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/log`).get();
  }

  getCargaBalanca(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body) 
  }
}

export default ExportacaoBalancaService;
